import forEach from 'lodash/forEach';
import isNumber from 'lodash/isNumber';
import join from 'lodash/join';
const PART_URL_GOOGLE_MAP_PLACE = 'https://www.google.com/maps/dir';
const GOOGLE_API_VERSION = 'api=1';
export const getDirectionLink = (from, to) => {
    const queryParams = join([
        GOOGLE_API_VERSION,
        `origin=${from}`,
        `destination=${to}`,
        'travelmode=driving',
        'map_action=map',
    ], '&');
    return `${PART_URL_GOOGLE_MAP_PLACE}/?${queryParams}`;
};
export const getCoordsStringByLocation = (location) => location?.lat && location?.lng ? `${location?.lat}, ${location?.lng}` : '';
export const getBoundsByPoints = (points) => {
    const bounds = new google.maps.LatLngBounds();
    forEach(points, ({ lat, lng }) => {
        if (isNumber(lat) && isNumber(lng)) {
            bounds.extend({
                lat,
                lng,
            });
        }
    });
    return bounds;
};
